import { yupResolver } from "@hookform/resolvers/yup";
import { PairSmartPayFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";
import { defaultFormValues as _defaultFormValues } from "./constants";

export interface PairSmartPayFormProps {
  defaultFormValues?: Partial<PairSmartPayFormValues>;
  children?: React.ReactNode;
}

export const PairSmartPayForm = ({
  defaultFormValues,
  children,
}: PairSmartPayFormProps) => {
  const methods = useForm<PairSmartPayFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
